/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Has_ParkingInputs */

const cs_form_has_parking = /** @type {(inputs: Form_Has_ParkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parkování`)
};

const en_form_has_parking = /** @type {(inputs: Form_Has_ParkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parking`)
};

/**
* | output |
* | --- |
* | "Parking" |
*
* @param {Form_Has_ParkingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_has_parking = /** @type {((inputs?: Form_Has_ParkingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Has_ParkingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_has_parking(inputs)
	return cs_form_has_parking(inputs)
});